import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "../utils/analytics";

/** Records client-side route changes after the base Pixel's initial PageView. */
export function MetaPixelRouteSync() {
  const { pathname, search } = useLocation();
  const lastPath = useRef(`${pathname}${search}`);

  useEffect(() => {
    const nextPath = `${pathname}${search}`;
    if (nextPath === lastPath.current) return;
    lastPath.current = nextPath;
    trackMetaPageView();
  }, [pathname, search]);

  return null;
}
